import { render, staticRenderFns } from "./ExpansionPanels.vue?vue&type=template&id=31fbb2d4&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fbb2d4')) {
      api.createRecord('31fbb2d4', component.options)
    } else {
      api.reload('31fbb2d4', component.options)
    }
    module.hot.accept("./ExpansionPanels.vue?vue&type=template&id=31fbb2d4&", function () {
      api.rerender('31fbb2d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ExpansionPanels.vue"
export default component.exports